(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ann-bar]').forEach(function (bar) {
      var key = 'citera:ann:' + bar.getAttribute('data-ann-key');
      try {
        if (localStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
      var close = bar.querySelector('[data-ann-close]');
      if (close) {
        close.addEventListener('click', function () {
          bar.hidden = true;
          try {
            localStorage.setItem(key, '1');
          } catch (e) {}
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    // Scroll reading-progress bar
    var bar = document.querySelector('[data-reading-progress]');
    var content = document.querySelector('.article__content');
    if (bar && content) {
      var update = function () {
        var rect = content.getBoundingClientRect();
        var total = content.offsetHeight - window.innerHeight + rect.height * 0;
        var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
        var pct = total > 0 ? (scrolled / total) * 100 : 0;
        bar.style.width = pct + '%';
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    // Copy-link share button
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy-link]');
      if (!btn) return;
      var url = btn.getAttribute('data-url');
      var done = function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const openBtn = document.querySelector('[data-zoom-open]');
    const dialog = document.querySelector('[data-lightbox]');
    if (!openBtn || !dialog || typeof dialog.showModal !== 'function') return;
    const lbImg = dialog.querySelector('[data-lightbox-img]');
    const main = document.getElementById('product-media-main');
    const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
    const urls = thumbs.length
      ? thumbs.map((t) => t.dataset.full)
      : [main ? main.currentSrc || main.src : ''];
    // Keep alt text in sync when arrow-navigating between images.
    const alts = thumbs.length
      ? thumbs.map((t) => {
          const img = t.querySelector('img');
          return (img && img.alt) || '';
        })
      : [main ? main.alt || '' : ''];
    let idx = 0;
    const show = (i) => {
      idx = (i + urls.length) % urls.length;
      lbImg.src = urls[idx];
      lbImg.alt = alts[idx] || lbImg.alt;
    };
    const activeIndex = () => {
      const a = thumbs.findIndex((t) => t.getAttribute('aria-pressed') === 'true');
      return a >= 0 ? a : 0;
    };
    openBtn.addEventListener('click', () => {
      show(activeIndex());
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      const closeBtn = dialog.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    });
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => show(idx - 1));
    dialog.querySelector('[data-lightbox-next]')?.addEventListener('click', () => show(idx + 1));
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
    // Return focus to the zoom trigger when the lightbox closes (WCAG 2.4.3).
    dialog.addEventListener('close', () => openBtn.focus());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-slideshow]').forEach((root) => {
    const track = root.querySelector('[data-slideshow-track]');
    const slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-slideshow-dot]'));
    if (!track || slides.length < 2) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;

    const go = (i, smooth = true) => {
      current = (i + slides.length) % slides.length;
      track.scrollTo({
        left: slides[current].offsetLeft,
        behavior: smooth && !reduce ? 'smooth' : 'auto',
      });
    };

    root.querySelector('[data-slideshow-next]')?.addEventListener('click', () => go(current + 1));
    root.querySelector('[data-slideshow-prev]')?.addEventListener('click', () => go(current - 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));

    // Sync dots with the visible slide
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            current = slides.indexOf(e.target);
            dots.forEach((d, i) =>
              d.setAttribute('aria-current', i === current ? 'true' : 'false'),
            );
            // Keep off-screen slides out of the tab order and AT.
            slides.forEach((s, i) => {
              if (i === current) {
                s.removeAttribute('inert');
                s.removeAttribute('aria-hidden');
              } else {
                s.setAttribute('inert', '');
                s.setAttribute('aria-hidden', 'true');
              }
            });
          }
        });
      },
      { root: track, threshold: 0.6 },
    );
    slides.forEach((s) => io.observe(s));

    // Autoplay (disabled for reduced motion; pauses on hover/focus and via toggle)
    if (root.dataset.autoplay === 'true' && !reduce) {
      const speed = Math.max(2, parseInt(root.dataset.autoplaySpeed, 10) || 6) * 1000;
      const toggle = root.querySelector('[data-slideshow-toggle]');
      let timer = setInterval(() => go(current + 1), speed);
      // Manual pause via the toggle overrides hover/focus resume.
      let paused = false;
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };
      const start = () => {
        if (!paused && !timer) timer = setInterval(() => go(current + 1), speed);
      };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      toggle?.addEventListener('click', () => {
        paused = !paused;
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.setAttribute(
          'aria-label',
          paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause,
        );
        if (paused) {
          stop();
        } else {
          start();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
